import Col from './col';
import {mapChildren, getRestProps} from '../utils';
import gutterStyle from './utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    let {
    children, className, style,
    justify, align
} = self.get();
const useFlex = self.useFlex;

let gutter = self._getGutter();
let hasGutter = gutter > 0;
if (hasGutter) {
    style = gutterStyle(gutter, style);
}

const classNameObj = {
    'k-row': true,
    [className]: className,
    'k-gutter': hasGutter,
    'k-flex': useFlex,
    [`k-justify-${justify}`]: justify,
    [`k-align-${align}`]: align,
};

/* if (Array.isArray(children)) { */
    /* // order the children by order property like flex's order */
    /* children.sort((a, b) => { */
        /* return (a && a.props && a.props.order || 0) -  */
            /* (b && b.props && b.props.order || 0); */
    /* }); */
/* } */

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'style': function() {try {return (style )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return (mapChildren(children, vNode => {
        if (vNode && vNode.tag === Col) {
            vNode.props = {...vNode.props, gutter};
            // make it clone
            vNode.$ = true;
            /* return _Vdt.miss.clone(vNode, {gutter}); */
        }
        return vNode;
    }) 
    )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}